<template>
    <div class="container">
        Contact Page
    </div>
</template>
<script>
export default {};
</script>
